import mainCaller from './mainCaller';

// 센터(지점) 앱 노출 토글
export async function toggleBranchExposure(token, branchId, exposureYn) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/exposure?exposureYn=${exposureYn}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 지점 운영형태 변경 (직영/가맹/기타, #73 수강권 다지점 공유는 직영끼리만)
export async function updateBranchOperationType(token, branchId, operationType) {
  return await mainCaller(`admin/api/v1/branches/${branchId}/operation-type?operationType=${operationType}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 수강권 앱 노출 토글
export async function toggleTicketExposure(token, id, exposureYn) {
  return await mainCaller(`admin/api/v1/course/tickets/${id}/exposure?exposureYn=${exposureYn}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 이용권 앱 노출 토글
export async function togglePassExposure(token, id, exposureYn) {
  return await mainCaller(`admin/api/v1/course/passes/${id}/exposure?exposureYn=${exposureYn}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 일일권 앱 노출 토글
export async function toggleTrialExposure(token, id, exposureYn) {
  return await mainCaller(`admin/api/v1/trial-tickets/${id}/exposure?exposureYn=${exposureYn}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 직원 앱 노출 토글
export async function toggleEmployeeExposure(token, id, exposureYn, branchId) {
  const branchQuery = branchId ? `&branchId=${branchId}` : '';
  return await mainCaller(`admin/api/v1/employees/${id}/exposure?exposureYn=${exposureYn}${branchQuery}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
}

// 안면인식 출입문 체계 사용 여부 (#91) — Y 인 지점만 시설 제어에서 출입문 전환이 열린다
export const updateBranchDoorSystem = async (token, branchId, doorSystemYn) => {
  return await mainCaller(`admin/api/v1/branches/${branchId}/door-system?doorSystemYn=${doorSystemYn}`, 'PATCH', null, {
    Authorization: `Bearer ${token}`,
  });
};
